import React from "react";
import CardTag from "./CardTag";
import { Link } from "react-router-dom";
import { Media } from "../../compilers/media";
import "../../stylesheet/components/contentcards/ContentCard.scss";
import trimText from "../utilities/trimText";
import i18n from "../../api/i18n";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import profile from "../../assets/profile.png";

interface ContentCardProps {
  ClassName?: string;
  media: Media;
  section_type: string;
}

const ContentCard: React.FC<ContentCardProps> = ({
  ClassName,
  media,
  section_type = "cafe",
}) => {
  const { t, ready } = useTranslation();

  // const bookMarkIcon = useRef<HTMLImageElement>(null);
  // useEffect(() => {
  // 	// On mouse over
  // 	bookMarkIcon.current?.addEventListener("mouseover", () => {
  // 		bookMarkIcon.current?.setAttribute("src", "/img/icon/bookmark-hover.svg");
  // 	})
  // 	// On mouse out
  // 	bookMarkIcon.current?.addEventListener("mouseout", () => {
  // 		bookMarkIcon.current?.setAttribute("src", "/img/icon/bookmark.svg");
  // 	})
  // })
  // gets a paragraph with the relative date string, ie: 4 days ago etc
  const getRelativeDate = () => {
    if (section_type === "academyupcoming") {
      return;
    }
    if (section_type !== "academy" && media.data.publishDate) {
      const publishDate = new Date(media.data.publishDate);
      const todayDate = new Date();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const diffTime = Math.abs(todayDate - publishDate);
      let relativeDaysQualifier = `${t("content-card.days-ago")}`;
      if (todayDate < publishDate) {
        relativeDaysQualifier = `${t("content-card.days-after")}`;
      }

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (i18n.language === "ar") {
        if (diffDays === 1) {
          return <p className="p2">منذ يوم واحد</p>;
        } else if (diffDays === 2) {
          return <p className="p2">منذ يومين</p>;
        } else {
          return (
            <p className="p2">
              {"منذ" + ` ${diffDays.toLocaleString("ar-EG")} ` + "أيام"}
            </p>
          );
        }
      }
      return <p className="p2">{`${diffDays} ${relativeDaysQualifier}`}</p>;
    }
  };

  const getImage = () => {
    let imgSrc =
      "https://firebasestorage.googleapis.com/v0/b/zefi-production.appspot.com/o/placeholder-images%2Fzefi-placeholder-hero-grey.png?alt=media&token=a0feabf5-d9bc-4d3a-a2ec-7083b5693911";
    if (media.data.heroImage.length > 0) {
      imgSrc = media.data.heroImage;
    }
    return <img src={imgSrc} alt="" className="card-img" />;
  };

  const getImagePills = () => {
    return (
      <div className="image-pills">
        {media.data.yellowPillText && media.data.yellowPillText.length > 0 ? (
          <div className="yellow-pill">{media.data.yellowPillText}</div>
        ) : (
          <div />
        )}
        {media.data.bluePillText && media.data.bluePillText.length > 0 ? (
          <div className="blue-pill">{media.data.bluePillText}</div>
        ) : (
          <div />
        )}
      </div>
    );
  };

  const getTags = () => {
    if (media.data.tags.length === 0) {
      return;
    }
    const getRenderedTags = () => {
      const renderedTags = media.data.tags.slice(0, 2);
      return renderedTags.map((tagItem) => (
        <CardTag key={tagItem} title={tagItem} />
      ));
    };
    const getAdditionalTags = () => {
      if (media.data.tags.length - 2 >= 1) {
        return <CardTag title={`+${media.data.tags.length - 2}`} />;
      }
      return;
    };
    if (media.data.tags) {
      return (
        <div className="flex-r my-1">
          {getRenderedTags()}
          {getAdditionalTags()}
        </div>
      );
    }
    return <div />;
  };

  const getAuthor = () => {
    let imgSrc = profile;
    // "https://firebasestorage.googleapis.com/v0/b/zefi-cms.appspot.com/o/Authors%2Fimage%2050.png?alt=media&token=c72850a8-6c83-4681-bb2a-862073c6f5ae";
    if (media.data.author) {
      if (media.data.authorImage) {
        imgSrc = media.data.authorImage;
      }
      return (
        <div className="content-author flex-r">
          <img src={imgSrc} className="author-image" />
          <p className="tag">{media.data.author}</p>
        </div>
      );
    }
  };

  const getCategory = () => {
    if (section_type === "cafe") {
      return (
        <p className="cta">
          {" "}
          {(media.data.category && media.data.category.length > 0
            ? media.data.category
            : `${t("content-card.uncategorized")}`
          ).toUpperCase()}{" "}
        </p>
      );
    }

    return (
      <p className="cta">
        {" "}
        {(media.data.type && media.data.type.length > 0
          ? media.data.type
          : `${t("content-card.uncategorized")}`
        ).toUpperCase()}
      </p>
    );
  };

  const getReadingTime = () => {
    if (media.data.readingTime && typeof media.data.readingTime !== "string") {
      return (
        <p className="p2 reading-time">
          {Math.ceil(media.data.readingTime.minutes)}{" "}
          {ready ? t("content-card.mins") : <Skeleton width={80} />}{" "}
        </p>
      );
    } else {
      return (
        <p className="p2 reading-time">
          {media.data.readingTime}{" "}
          {ready ? t("content-card.mins") : <Skeleton width={80} />}{" "}
        </p>
      );
    }
  };

  const getPrice = () => {
    if (section_type === "academy") {
      return (
        <h5 className="mt-1">
          {" "}
          {ready ? t("content-card.free") : <Skeleton width={80} />}
        </h5>
      );
    }
    if (section_type === "academyupcoming") {
      //split and get month and date
      const dateArray = media.data.publishDate.split(" ");
      const date = dateArray[1] + " " + dateArray[2];
      return (
        <h5 className="mt-1">
          {" "}
          {ready ? (
            `${t("content-card.upcoming")} ${date}`
          ) : (
            <Skeleton width={80} />
          )}
        </h5>
      );
    }
  };

  // const getBookmark = () => {
  // 	return <a className="bookmark-link" href="https://www.google.com"><img ref={bookMarkIcon} className="bookmark-icon" src="/img/icon/bookmark.svg"></img></a>
  // }

  if (
    media.data.yellowPillText &&
    media.data.yellowPillText.includes("Blockchain for ") &&
    !media.data.yellowPillText.includes("everyone")
  ) {
    media.data.yellowPillText = media.data.yellowPillText.slice(
      14,
      media.data.yellowPillText.length
    );
  }

  return (
    <>
      <Link
        className={`${ClassName && ClassName}`}
        style={{
          textDecoration: "none",
        }}
        to={`/${i18n.language}/${section_type}/catalogue/${media.data.slug}`}
      >
        <div className="card-outer">
          <div className="card-img-container">
            {getImagePills()}
            {getImage()}
          </div>
          <div className="card-inner">
            <div className="card-inner-top">
              <div className="flex-r flex-s-between">
                {getCategory()}
                {getReadingTime()}
              </div>
              <h5>{media.data.title}</h5>
              <p className="p2 blurb">
                {media.data.blurb ? trimText(media.data.blurb) : ""}
              </p>
            </div>
            <div className="position-relative flex-column">
              {getAuthor()}
              {getTags()}
              {getRelativeDate()}
              {getPrice()}
              {/*{getBookmark()}*/}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default ContentCard;
